"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = exports.TEST_ID_ICON_BUTTON = void 0;
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
exports.TEST_ID_ICON_BUTTON = "iconButton";
function IconButton(_a) {
    var icon = _a.icon, onClick = _a.onClick, title = _a.title, type = _a.type, csx = _a.csx;
    return (react_1.default.createElement(theme_ui_1.IconButton, { type: type, "data-testid": exports.TEST_ID_ICON_BUTTON, onClick: onClick, sx: __assign(__assign({}, csx), { maskImage: "url(" + icon + ")" }), title: title }));
}
exports.IconButton = IconButton;
